import React from 'react';
import QRCode from 'react-qr-code';

import { Button, Heading, Link, Modal, Text } from '@auspost/postmaster-react';

import { ReactComponent as DigitalID } from 'assets/digital-id.svg';
import { extLnkCheckID, extLnkDigitalId } from 'config/track-config';

import styles from './QrCodeModal.module.scss';

export interface QrCodeModalProp {
  trackingId: string;
  isOpen: boolean;
  handleClose: () => void;
}

const QrCodeModal: React.FC<QrCodeModalProp> = ({ trackingId, isOpen, handleClose }) => {
  return (
    <Modal
      isModalShowing={isOpen}
      onHide={handleClose}
      modalClassName={styles.qrCodeModal}
      dialogClassName={styles.qrCodeDialog}
      ariaDialogLabel='QR code modal'
      dialogId='QR code modal'
    >
      <Modal.Header closeButton={true} className={styles.header}>
        <Heading level='h3'>Collection QR code</Heading>
      </Modal.Header>

      <Modal.Content className={styles.content}>
        <div className={styles.qrCode}>
          <QRCode value={trackingId} size={192} aria-label='Collection QR code' />
        </div>
        <Text variant='body-small'>
          Show this QR code at the counter along with your&nbsp;
          <Link variant='text' href={extLnkCheckID} target='_blank'>
            proof of identity
          </Link>
          .
        </Text>
        <a
          href={extLnkDigitalId}
          className={styles.digitalIdLink}
          target='_blank'
          rel='noreferrer'
          aria-label='Use my Digital ID'
        >
          Use my
          <DigitalID />
        </a>
      </Modal.Content>
      <Modal.Footer className={styles.footer}>
        <Button onClick={handleClose} size='medium' variant='primary' className={styles.closeButton}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QrCodeModal;
